import { forwardRef, Ref } from 'react';

import { Kit, KitType } from '@repo/types';
import LogoSvg from 'assets/images/logos/logo-full.svg';
import { getTextColorFromEvaluationColor } from '@repo/ui';
import { Typography } from 'components';
import MicrobiomeScoreChart, {
  Legend,
} from 'components/MicrobiomeScoreChart/MicrobiomeScoreChart';

import styles from './MicrobiomeScoreShareImage.module.css';

type Props = {
  kit: Kit;
  popScore: number;
  color?: string;
};

const MicrobiomeScoreShareImage = forwardRef(function MicrobiomeScoreShareImage(
  { kit, popScore, color }: Props,
  ref,
) {
  const isVaginal = kit.sampling_type === KitType.VAGINAL;

  return (
    <div
      className={styles.cardContainer}
      ref={ref as Ref<HTMLDivElement> | null}
    >
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <Typography variant='heading-m'>
            {isVaginal ? 'Vaginal microbiome score' : 'Gut microbiome score'}
          </Typography>
        </div>
        <div className={styles.chartContainer}>
          <div className={styles.percentile}>
            <Typography
              variant='display-l'
              color={getTextColorFromEvaluationColor(color ?? 'grey')}
            >
              {Math.round(popScore)}
            </Typography>
            <span className='dark-grey'>/ 100</span>
          </div>
          <MicrobiomeScoreChart
            kit={kit}
            popScore={popScore}
            isImage
            disableAnimations
            bottomLabel='Microbiome summary score (MSS)'
            customHeight={265}
          />
        </div>
        <div className={styles.legendContainer}>
          <Legend
            isVaginal={isVaginal}
            mode='horizontal'
            gap='0.5rem'
            itemGap='0.25rem'
            rectClassName={styles.legendRect}
          />
        </div>
      </div>
      <div className={styles.footer}>
        <span className={styles.url}>www.tinyhealth.com</span>
        <img src={LogoSvg} className={styles.logo} />
      </div>
    </div>
  );
});

export default MicrobiomeScoreShareImage;
